import React, { memo } from "react";
import styled from "styled-components";
import { positiveColor } from "../../../helpers/color";
import { transparentizedDefaultColor } from "../../../helpers/transparentize";
import { useScope } from "./state/scope";
import { useProofed } from "./state/proofed";
const Root = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1j2drjy-0"
})(["z-index:1;position:absolute;top:0;left:0;bottom:0;background-color:", ";transform:translateX(-1px);&::after{content:\"\";position:absolute;top:0;right:-2px;bottom:0;border-right:2px dashed ", ";}"], transparentizedDefaultColor, positiveColor));
const Proofed = /*#__PURE__*/memo(() => {
  const scope = useScope();
  const proofed = useProofed();
  const displayLength = Math.max(0, Math.min(scope.length, proofed - scope.start));
  return /*#__PURE__*/React.createElement(Root, {
    style: {
      width: `${displayLength / scope.length * 100}%`
    }
  });
});
export default Proofed;
//# sourceMappingURL=Proofed.js.map